import {
  SearchLength,
  SearchReactionConfidenceThreshold,
  SearchSynthesisScale,
} from './search-types';
import type { Config } from '@retro-ui/config';

type ModelsConfig = Config['global']['batchSearch']['models'];
type DatasetsConfig = Config['startingMaterial']['predefinedDatasets'];

export const M1_DEFAULT = 'M1';
export const BASE_PRESET_NAME = 'base-parameters';

export const MIN_REFERENCE_COUNT_RANGE = [0, 1000];
export const MIN_REFERENCE_COUNT_DEFAULT = 10;
export const REACTION_CONFIDENCE_THRESHOLD_DEFAULT = SearchReactionConfidenceThreshold.HIGH;

export const MIN_N_PROVIDERS_RANGE = [0, 100];
export const MIN_N_PROVIDERS_DEFAULT = 3;

export const MAX_N_ATOMS_DEFAULT = 1000;
export const MAX_PRICE_DEFAULT = 100000;
export const MAX_PRICE_PER_GRAM_DEFAULT = 100000;

export const buildDefaultSearchParams = (
  models: ModelsConfig,
  predefinedDatasets: DatasetsConfig
): any => ({
  length: SearchLength.SHORT,
  model: models.find(m => m.id === 'transformer') ? 'transformer' : 'metro',
  datasets: predefinedDatasets
    .filter(dataset => dataset.initiallySelected)
    .map(dataset => ({ id: dataset.id })),
  synthesis_scale: SearchSynthesisScale.MILLIMOLAR,
  availability_tier: 3,
  reaction_confidence_threshold: REACTION_CONFIDENCE_THRESHOLD_DEFAULT,
  min_reference_count: MIN_REFERENCE_COUNT_DEFAULT,
  excluded_smiles: [],
  min_n_providers: MIN_N_PROVIDERS_DEFAULT,
  max_n_atoms: MAX_N_ATOMS_DEFAULT,
  max_price: MAX_PRICE_DEFAULT,
  max_price_per_gram: MAX_PRICE_PER_GRAM_DEFAULT,
});
